export const userCredentialActions = {
    CONFIRM: 'confirm',
    REJECT: 'reject',
    REMOVE: 'remove'
}
